module.exports = __webpack_public_path__ + "static/media/output.70b52376.png";